import React from 'react'
import styled from 'styled-components';
import resume from '../img/resume.jpg';
import PrimaryButton from './PrimaryButton';



function ImageSection() {
    return (
        <ImageSectionStyled>
            <div className="left-content">
                <img src={resume} alt=""/>
            </div>
            <div className="right-content">
                <h4><span>Prabhu Kumar Saw</span></h4>
                <p className="paragraph">
              I’m a passionate full-stack developer and freelancer with two years of experience. My journey began in college, where I tackled complex challenges and discovered innovative solutions. Having solved 500 competitive programming problems, I’ve mastered problem-solving and technical skills. On my blog, I share compelling insights and experiences from my career, aiming to inspire and guide you on your own path to success.... Thank You:)
                    
                </p>
                <div className="about-info">
                    <div className="info-title">
                        
                        <p>Profession</p>
                        <p>Nationality </p>
                        <p>Languages </p>
                        
                    </div>
                    <div className="info">
                       
                        <p>: Software Engineer, Freelancer, Traveller</p>
                        <p>: Indian </p>
                        <p>: Hindi, English </p>
                       
                    </div>
                </div>
                <PrimaryButton title={'Download Cv'} />
            </div>
        </ImageSectionStyled>
    )
}


const ImageSectionStyled = styled.div`
    margin-top: 5rem;
    display: flex;
    @media screen and (max-width:1000px){
        flex-direction: column;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    .left-content{
        width: 100%;
        img{
            width: 95%;
            height: 67%;
            object-fit: cover;
        }
    }
    .right-content{
        width: 100%;
        h4{
            font-size: 2rem;
            color: var(--white-color);
            span{
                font-size: 2rem;
            }
        }
        .paragraph{
            padding: 1rem 0;
        }
        .about-info{
            display: flex;
            padding-bottom: 1.4rem;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
    }
`;
export default ImageSection;
